import React, { useEffect } from 'react'
import Newbanner from './Newbanner'
import StatsSection2 from './StatsSection2'
import Header3 from '../../../Layout/Header3'
import NewWinnersHomeCities from './NewWineersHomeCities'
import NewLocationins from './NewLocationins'
import NewUpcomingProjects from './NewUpcomingProjects'
import NewAboutWinner from './NewAboutWinner'
import NewWinnerHomeCities from './NewWinnerHomeCities'
import NewWallofFame from './NewWalloFame'
import NewTestimonial2 from './NewTestimonial2'
import NewFAQ from './NewFAQ'
import NewTopProject from './NewTopProject'

function Newhome() {
   const allowedCitiesOne = [" Allahabad", "Lucknow", "Dwarka", "Kanpur Nagar"];
    const allowedCitiesTwo = [
      "Gurgaon",
      "Faridabad",
      "South Delhi",
      "West Delhi",
      "East Delhi",
      "Central Noida",
      "Greater Noida",
      "Indirapuram",
      "Noida Extension",
    ];
    useEffect(()=>{
      window.scrollTo({top:0,behavior:"smooth"})
    },[])
  return (
     <div className="home2-main-wrapper">
      <Header3/>
      <Newbanner />
      <StatsSection2 />
      <NewWinnersHomeCities
      allowedCities={allowedCitiesOne}
       title={"Upcoming Cites"}/>
      <NewLocationins/>
      <NewTopProject/>
      <NewUpcomingProjects/>
      <NewAboutWinner/>
      <NewWinnersHomeCities 
       allowedCities={allowedCitiesTwo}
       title={"Working in cities"}/>
       <NewWallofFame/>
       <NewTestimonial2/>
       <NewFAQ/>
    </div>
  )
}

export default Newhome